export const AUTH_USER_ROUTE = '/dashboard/profile';
export const ANONYM_USER_ROUTE = '/';
